function httpsUrlToDisplayWithoutScheme(parsed: URL) {
  let result = parsed.hostname;
  if (parsed.pathname !== '/' || parsed.search || parsed.hash) {
    result += parsed.pathname;
  }
  result += parsed.search;
  result += parsed.hash;
  return result;
}

export function normalizeEditorLinkHref(raw: string): string | null {
  const trimmed = raw.trim();
  if (trimmed === '') {
    return null;
  }

  let parsed: URL;
  try {
    parsed = new URL(trimmed);
  } catch {
    try {
      parsed = new URL(`https://${trimmed}`);
    } catch {
      return null;
    }
  }

  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
    return null;
  }

  return parsed.href;
}

export function editorLinkHrefToDisplayInput(href: string): string {
  const trimmed = href.trim();
  if (trimmed === '') {
    return '';
  }
  try {
    const parsed = new URL(trimmed);
    if (parsed.protocol === 'https:') {
      return httpsUrlToDisplayWithoutScheme(parsed);
    }
    return trimmed;
  } catch {
    return trimmed;
  }
}
